import Box from '@mui/material/Box';

export function LogoContainer({ children }: React.PropsWithChildren<{}>) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      {children}
    </Box>
  );
}
